var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-slate-100"},[_c('HeroView',{}),_c('MissionView',{staticClass:"page-spacer"}),_c('FeaturesView',{staticClass:"page-spacer"}),_c('UserReviews'),_c('OurPartners')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }